import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';
import { UtilityService } from '@eforall/common';
import { DialogService, GridContentWidget, PageTabsMainTabGridSize } from '@eforall/dashboard';
import { AccMentorFuncData } from '@interfaces';
import { AcceleratorAreaService } from '../../../../accelerator-area.service';
import { AccCohortPageService, } from '../../../acc-cohort.page.service';
import { getSetup } from './grid/get-setup';

export interface AccMentor extends AccMentorFuncData {
	teamName: string | undefined,
	ventures: string | undefined,
}


@Component({
	selector: 'acc-mentors-view-part',
	standalone: true,
	imports: [GridContentWidget],
	changeDetection: ChangeDetectionStrategy.Eager,
	templateUrl: './acc-mentors-view.part.html',
})
export class AccMentorsViewPart {

	private readonly util = inject(UtilityService);
	private readonly dialogService = inject(DialogService);
	private readonly pageService = inject(AccCohortPageService);
	private readonly areaService = inject(AcceleratorAreaService);

	public setup = getSetup(this.util, this.dialogService, this.areaService);

	public pageTabsGridSize = computed<PageTabsMainTabGridSize | undefined>(() => {
		if (this.pageService.layout()) return { layout: this.pageService.layout()!, viewSelector: true };
		return undefined;
	});

	public accMentors = computed<AccMentor[]>(() => {
		const data = this.areaService.data();
		const accTeamMap = this.areaService.accTeamMap();
		if (!data) return [];

		return data.mentors.map(m => {
			const accTeam = accTeamMap[m.accTeamId];
			return {
				...m,
				teamName: accTeam?.name,
				ventures: accTeam?.ventures,
			}
		});
	});

}